/**
 * Statically-bundled spots list. Imported directly from `src/spots.json`
 * so the regions overview, search, and any other surface that only needs
 * spot metadata (name, area, region, coords, ideal/secondary ranges) can
 * render without waiting on `/api/forecast`.
 *
 * Wind data still flows through `useForecast()` / `/api/forecast` — see
 * docs/decisions.md "One wind data pipeline for every location". This
 * module only exposes the static metadata that doesn't change between
 * requests.
 */
import spotsJson from "../spots.json";
import type { Spot } from "./types";

export const STATIC_SPOTS: readonly Spot[] = spotsJson as Spot[];
